import { $subscriber, interact } from "fire-wind-water";
import settingPc from "@/sktempjson/questionary-pc.json";
import settingWap from "@/sktempjson/questionary-wap.json";
import { $extras, $messageLoad } from "@/../stempcore/src/core/sextra.js";
import { URLS } from "fire-wind-water/index";
import Api from "../service/api";

let templateMixin = {
  data() {
    return {
      extras: {},
      isSetting: Number(URLS.getURL("isSetting")),
    };
  },
  created() {
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", (o) => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        let bgColor = this.extras.themecolor.bgcolor;
        if (bgColor.indexOf("#") > -1) {
          bgColor = this.colorRgb(bgColor);
        }
        const rgbaAttr = bgColor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  },
  methods: {
    colorRgb(value) {
      // 16进制颜色值的正则
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把颜色值变成小写
      var color = value.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          var colorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return "RGB(" + colorChange.join(",") + ")";
      } else {
        return color;
      }
    },
    initConfig(configId, tenantId) {
      if (this.isSetting) {
        // if (process.env.NODE_ENV === "development") {
        this.extras = $extras(
          interact.isMobile ? settingWap.html : settingPc.html
        ).extras;
        // }
        return;
      }
      Api.getTemplateConfig({
        tenantId: tenantId,
        configId: configId,
      }).subscribe((res) => {
        // this.extras = $extras(interact.isMobile ? settingWap.html : settingPc.html).extras;
        this.extras = $extras(res.content.info.html).extras;
        if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
          let themeColorClear = "";
          let bgColor = this.extras.themecolor.bgcolor;
          if (bgColor.indexOf("#") > -1) {
            bgColor = this.colorRgb(bgColor);
          }
          const rgbaAttr = bgColor.match(/[\d.]+/g);
          if (rgbaAttr.length >= 3) {
            let r, g, b;
            r = rgbaAttr[0];
            g = rgbaAttr[1];
            b = rgbaAttr[2];
            themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
          }
          document.body.style.setProperty(
            "--themeColor",
            this.extras.themecolor.bgcolor
          );
          document.body.style.setProperty("--themeColorClear", themeColorClear);
        }
      });
    },
  },
};

export default templateMixin;
